$(document).ready(function(){
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca [ i ];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkNLCookie() {
    var popUp = getCookie("nlPoppedUp");
    if (popUp != "") {}
    else {
      var popUp = 1;
      setCookie("nlPoppedUp", popUp, 1);
      $('#nlModal').show();
      $('body').addClass('no-scroll');
    }
  }
  
  $('.announcement-bar__message').click(function(){
    $('#nlModal').show();
    $('body').addClass('no-scroll');
  });

  if($('#nlModal').length > 0){
    setTimeout(function(){
      checkNLCookie();
      //$('#nlModal').show();
      //$('body').addClass('no-scroll');
    },10000);
  }

  $('.sk__relatedProducts').slick({
    dots: false,
    arrows:true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    prevArrow:'<button type="button" class="slide_arrows slick-prev"><span>‹</span></button>',
    nextArrow:'<button type="button" class="slide_arrows slick-next"><span>›</span></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    vertical: true
  });
  
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      this.parentNode.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }

});

$(window).scroll(function() {    
  var scrollTop = $(window).scrollTop();
  var scroll = 100;
  if (scrollTop >= scroll){
    $('.sk__siteHeader_wrap').addClass('fixed');
  }else{
    $('.sk__siteHeader_wrap').removeClass('fixed');
  }
});

$(document).on('click','.modal-close',function(e){
  $('.modal-container').hide();
  $('body').removeClass('no-scroll');
});

$(document).on('click','.modal-container',function(e){
  var container = $(".modal-content");
  if (!container.is(e.target)  && container.has(e.target).length === 0){
    $('.modal-container').hide();
    $('body').removeClass('no-scroll');
  }   
}); 


$(document).on('click','[data-quantity="plus"]',function(e){
  e.preventDefault();
  var fieldName = $(this).attr('data-field');
  var currentVal = parseInt($('input[name='+fieldName+']').val());
  if (!isNaN(currentVal)) {
    $('input[name='+fieldName+']').val(currentVal + 1);
  } else {
    $('input[name='+fieldName+']').val(0);
  }
});

$(document).on('click','[data-quantity="minus"]',function(e) {
  e.preventDefault();
  var fieldName = $(this).attr('data-field');
  var currentVal = parseInt($('input[name='+fieldName+']').val());
  if (!isNaN(currentVal) && currentVal > 0) {
    $('input[name='+fieldName+']').val(currentVal - 1);
  } else {
    $('input[name='+fieldName+']').val(0);
  }
});

$(document).on('click','ul.tabs li',function(){
  var tab_id = $(this).attr('data-tab');

  $('ul.tabs li').removeClass('active');
  $('.tab-content').removeClass('active');

  $(this).addClass('active');
  $("#"+tab_id).addClass('active');
});

$(document).on('click','.sk__tosagree',function(){
  $(".sk__collaborations_btn").attr("disabled", !this.checked);
});

$(document).on('click','.mobile__filter_btn',function(){
  $('.sk__filters_wrapper').slideToggle();
});
$(document).on('click','.sk__filter_label',function(){
  $('.sk__filter_values').slideToggle();
});